/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResendConfirmEmailInput
 */
export interface ResendConfirmEmailInput {
    /**
     * 
     * @type {string}
     * @memberof ResendConfirmEmailInput
     */
    email?: string;
}

/**
 * Check if a given object implements the ResendConfirmEmailInput interface.
 */
export function instanceOfResendConfirmEmailInput(value: object): value is ResendConfirmEmailInput {
    return true;
}

export function ResendConfirmEmailInputFromJSON(json: any): ResendConfirmEmailInput {
    return ResendConfirmEmailInputFromJSONTyped(json, false);
}

export function ResendConfirmEmailInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendConfirmEmailInput {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function ResendConfirmEmailInputToJSON(json: any): ResendConfirmEmailInput {
    return ResendConfirmEmailInputToJSONTyped(json, false);
}

export function ResendConfirmEmailInputToJSONTyped(value?: ResendConfirmEmailInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

